<script>
    import { getContext } from "svelte";
    import BoxShare from "./BoxShare.svelte";
    import ModelShare from "./ModelShare.svelte";
    let options = getContext('options');
</script>

{#if options.model_id}
    <ModelShare {...$$props} />
{:else}
    <BoxShare {...$$props} />
{/if}